export async function timer(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}
